/**
 * Created by comoon on 1/28/16.
 */

var _ = require('underscore');

var moment = require("moment");

var {CMEvent} = require("../lib/CMEvent");

var StoreMixin = require("./StoreMixin");

var Dispatcher = require("../Dispatcher");

var {ActionConstants, EventConstants} = require("../Constants");

var {query, post} = require("../util/ajax");

var StartCityList = require("../conf/start-city");

var QuoteStatus = require("../conf/quote-status");

var TripType = require("../conf/trip-type");

var TripStatus = require("../conf/trip-status");

var pollQuoteService = require("../detail/pollQuoteService");

/**
 * 当前行程的ID
 * @type {number}
 * @private
 */
var _tripId = 0;

/**
 * 用户角色(默认为未登录用户)
 */
var _role = 0;

var _currentRecordKey = null;

/**
 * 当前选中产品包的ID
 * @type {null}
 * @private
 */
var _currentVersionId = null;

/**
 * 未登录时的默认ID
 * @type {null}
 * @private
 */
var _defaultVersionId = null;

/**
 * 最后一次提交的版本号
 * @type {null}
 * @private
 */
var _lastCommitVersionId = null;

/**
 * 当前行程基本信息
 * @type {null}
 * @private
 */
var _tripInfo = null;

/**
 * 当前行程对应的报价申请结果记录
 * @type {Array}
 * @private
 */
var _quoteRecordList = [];

/**
 * 产品信息记录
 * @type {{}} key: versionId, value: productDetail
 * @private
 */
var _productInfo = {};

/**
 * 航空公司信息
 * @type {{}}
 * @private
 */
var _planeInfo = {};

/**
 * 二级口岸信息
 * @type {null}
 * @private
 */
var _portInfo = null;

/**
 * 用户可以询价次数
 * @type {null}
 * @private
 */
var _leftQueryCnt = null;

/**
 * 包含产品的计价结果
 * @type {Array}
 * @private
 */
var _validVersionList = [];


var _confirmUrl = null;

var _errors = {};

var _errorsCode = {};

/**
 * 改路线是否已经预定
 * @type {boolean}
 * @private
 */
var _hasBought = false;

/**
 * 切换品质/优选
 * @type {number}
 * @private
 */
var _gradeType = 0;

/**
 * 日历选择的时间
 * @type {null}
 * @private
 */
var _selectedStartDate = null;

/**
 * 地区数据
 * 洲,国家,分线,城市景点,亮点,主题,天数
 * @type {Array}
 * @private
 */
var _locationData = [];

/**
 * 查询产品列表
 * @type {null}
 * @private
 */
var _powerList = [];

var _isPowerListLast = false;

var _walleHasStartFalg = null;

var ALikeStore = _.extend({}, new CMEvent(), StoreMixin, {

    /**
     * 获取行程基本信息
     * @returns {*}
     */
    get_tripBasicInfo(){

        return _tripInfo;
    },

    /**
     * 获取报价申请结果列表
     * @returns {Array}
     */
    get_quoteRecordList(){

        return _quoteRecordList;
    },

    /**
     * 获取当前选中的记录
     * @returns {*}
     */
    get_currentRecord(){

        return _currentRecordKey;
    },

    /**
     * 判断是否存在 key
     */
    has_uidKey(){
        return _.has(_tripInfo,'key') && !!_tripInfo.key;
    },
    /**
     * 获取报价记录
     * @param inquiryKey
     */
    get_recordDetail(inquiryKey){

        return _.findWhere(_quoteRecordList, {inquiryKey});
    },

    /**
     * 获取当前选中版本
     * @returns {id}
     */
    get_currentVersion(){

        return _currentVersionId;
    },

    /**
     * 获取当前的出发日期
     */
    get_currentStartDate(){

        var startDate = null;
        var version =  this.get_versionDetail(this.get_currentVersion());

        if( version ){
            startDate = version.startDate
        }

        return startDate;
    },

    /**
     * 获取最后一次提交的版本号
     * @returns {*}
     */
    get_lastCommitVersion(){

        return _lastCommitVersionId;
    },

    /**
     * 获取指定version产品列表
     * 如果指定version没有产品信息,那么返回原包产品信息;如果_defaultVersionId不为空返回..
     * @param versionId
     * @returns {*}
     */
    get_productList(versionId){

        if (this.is_versionValid(versionId)) {

            return _productInfo[versionId];
        }

        if (_defaultVersionId){

            return _productInfo[_defaultVersionId];
        }

        return _productInfo[_tripInfo["versionId"]];
    },
    /**
     * 取得航空公司信息
     * @param versionId
     */
    get_planeInfo(versionId){

        if (this.is_versionValid(versionId)) {

            return _planeInfo[versionId];
        }

        return _planeInfo[_tripInfo["versionId"]];
    },

    /**
     * 获取商品列表的提示信息
     */

    get_productTips(){

        var tips = _tripInfo['productTips']

        if( tips && _.isEmpty(tips) ){
            return null
        }
        return _tripInfo['productTips']
    },
    /**
     * 获取指定version自己的产品列表
     * @param versionId
     * @returns {*}
     */
    get_versionOwnProductList(versionId){

        return _productInfo[versionId];
    },

    /**
     * 获取报价记录的默认版本
     * @param recordKey
     * @param whole 是否获取全部信息
     */
    get_recordDefaultVersion(recordKey, whole){

        var record = _.findWhere(_quoteRecordList, {inquiryKey: recordKey});

        var dayInfo = _.findWhere(record.priceCalenderDataList, {startDate: record.startDate});

        return whole ? dayInfo : dayInfo.versionId;
    },

    /**
     * 获取当前被选中日历的版本
     * @param recordKey
     * @param whole 是否获取全部信息
     */
    get_recordCurrentVersion(recordKey,whole){
        var record = _.findWhere(_quoteRecordList, {inquiryKey: recordKey});


        var dayInfo = _.findWhere(record.priceCalenderDataList, {versionId: _currentVersionId})
                   || _.findWhere(record.priceCalenderDataList, {startDate: record.startDate});

        return whole ? dayInfo : dayInfo.versionId;

    },


    /**
     * 获取报价版本
     * @param versionId
     * @returns {*}
     */
    get_versionDetail(versionId){

        var version = null;

        for (var i = 0; i < _quoteRecordList.length; i++) {

            var record = _quoteRecordList[i];

            version = _.findWhere(record.priceCalenderDataList, {versionId: versionId});

            if (version) {

                break;
            }
        }

        return version;
    },

    /**
     * 获取报价记录过期时间
     * @param inquiryKey
     * @returns {Number}
     */
    get_recordInvalidSeconds(inquiryKey){
        var record = this.get_recordDetail(inquiryKey);
        var expire = +moment(record.expireTime || '9999-12-31 23:59').toDate();
        return parseInt((expire - +new Date()) / 1000);

    },
    /**
     * 判断是否缺货,(有未包含产品)
     * @returns {boolean}
     */
    isAbsent(){
        var productInfo = this.get_currentProductList(false);
        if(_.isUndefined(productInfo)){
            return false
        }
            return !_.isEmpty(productInfo);
    },

    /**
     * 获取当前产品列表
     * @param contained
     * @returns {*}
     */
    get_currentProductList(contained){

        var productInfo = this.get_productList(_currentVersionId);

        if (!productInfo) {
            return null;
        }

        if (contained === 'whole') {
            return productInfo;
        }


        return contained ? productInfo.use : productInfo.out;
    },

    /**
     * 获取确认页URL
     */
    get_confirmUrl(){

        return _confirmUrl;
    },

    /**
     * 获取指定类型的错误消息
     * @param type
     */
    get_errorMsg(type){

        return _errors[type];
    },
    /**
     * 获取指定类型的错误CODE
     * @param type
     * @returns {*}
     */
    get_errorCode(type){

        return _errorsCode[type];
    },

    get_gradeType(){

        return _gradeType;
    },
    /**
     * 日历选择的日期
     * @returns {null}
     */
    get_selectedStartDate(){

        return _selectedStartDate;
    },
    /**
     * 获取二级口岸城市
     */
    get_portInfo(){
        return _portInfo;
    },
    /**
     * 获取得城市名称
     * @param cityId
     * @returns {*}
     */
    get_startCityName(cityId){
        var startCity =_.findWhere(_portInfo,{poi: cityId});
        return startCity.name
    },
    /**
     * 返回visa日历
     * @returns {*}
     */
    get_leftQueryCnt(){
        return _leftQueryCnt;
    },
    /**
     * 指定version是否包含产品列表
     * @param versionId
     */
    is_versionValid(versionId){

        return versionId && _.contains(_validVersionList, versionId);
    },

    /**
     * 当前版本是否有效
     */
    is_currentVersionValid(){

        return this.is_versionValid(_currentVersionId);
    },

    /**
     * 当前记录中询价类型为报价
     */
    is_quote(inquiryKey){
        
        var currentRecord = this.get_recordDetail(inquiryKey);

        if ( typeof  currentRecord.inquiryType === 'undefined'){
            
            throw new Error('报价数据错误,不存在报价类型');
            
        }
        return  currentRecord.inquiryType === 2;
    },

    /**
     * 检查当前产品信息是否被加载过
     * @param versionId
     * @returns {boolean}
     */
    is_productHasBeenLoaded(versionId){

        return _productInfo.hasOwnProperty(versionId);
    },

    /**
     * 判断行程是否被预定
     */
    is_tripHasBeenBought(){

        return _hasBought;
    },
    /**
     * 判断是否为默认的产品列表
     * 没有询价列表时,_currentVersionId=null
     */
    is_defaultProductInfo(){
        return !_currentVersionId ? true : false;
    },

    /**
     * 包含可用的报价
     * @returns {boolean}
     */
    has_quoteValid(){
        return _validVersionList.length > 0
    },
    /**
     * 取得大洲数据
     * @returns {*}
     */
    get_continents(){
        return _locationData.continents;
    },
    /**
     * 取国家
     * @param continentId
     * @returns {*}
     */
    get_countries(continentId){
        var continents = this.get_continents();
        var countries = _.findWhere(continents,{continentId: continentId}).countries;
        return countries;
    },
    /**
     * 由国家id，获取对应大洲id；
     *
     * */
    getContinentIdByCountryId(countryId){
      var continentId = ''
      , continents = this.get_continents()
      ;

      _.find(continents, function(continent){
        return _.find(continent.countries, function(item){
          if(item.countryId == countryId ){
            continentId = item.continentId;
          }
          return continentId;
        });
      });
 
      return continentId; 
    },
    /**
     * 取分线
     * @param continentId
     * @param countryId
     * @returns {*}
     */
    get_branches(continentId, countryId){
        var countries = this.get_countries(continentId);
        var branches = _.findWhere(countries,{countryId: countryId}).branches;
        return branches;
    },
    /**
     * 取得城市景点
     */
    get_cities(continentId, countryId, branchId){
        var self = this;
        var countries = this.get_countries(continentId);
        var cities;
        if(!branchId){
            cities = _.findWhere(countries,{countryId: countryId}).cities;
        }else{
            var branches = this.get_branches(continentId, countryId);
            var countries = _.findWhere(branches,{branchId: branchId}).countries;
            var cities = [];
            _.each(countries, function(i, j){
                var _cities = self.get_cities(continentId, i);
                cities = cities.concat(_cities);
            });
        }

        return cities;
    },
    /**
     * 取亮点数据
     */
    get_highlights(continentId, countryId, branchId){
        var branches = this.get_branches(continentId, countryId);
        var highlights = [];
        if(branchId){
            highlights = _.findWhere(branches,{branchId: branchId}).highlights;
        }else{
            _.each(branches, function(i,j){
                _.each(i.highlights, function(m,n){
                    var isPush = false;
                    _.each(highlights, function(v,k){
                        if(m.tagId === v.tagId){
                            v.num = (+v.num || 1) +1;
                            isPush = true;
                        }else{
                            m.num = 1;
                        }
                    })
                    if(!highlights.length){
                        m.num = 1;
                    }
                    if(!isPush){
                        highlights.push(m);
                    }
                });
            });
            highlights = _.sortBy(highlights, 'num').reverse();
        }
        return highlights;
    },
    /**
     * 取主题
     * @returns {*}
     */
    get_topics(){
        return _locationData.topics;
    },
    /**
     * 取出行天数
     */
    get_days(){
        return _locationData.days;
    },
    /**
     * 取排序
     */
    get_sorts(){
        return _locationData.sorts;
    },
    /**
     * 查询产品列表
     */
    get_powerList(){
        return _powerList;
    },
    /**
     * 是不到最终页
     * @returns {boolean}
     */
    get_isPowerListLast(){
        return _isPowerListLast;
    },
    /**
     * 查询产品列表
     */
    get_walleHasStartFalg(){
        return _walleHasStartFalg;
    }
});


ALikeStore.dispatchToken = Dispatcher.register(function (payload) {

    switch (payload.type) {

        case ActionConstants.COMMIT_APPLY:
            
            var recode;

            ALikeStore.emit_event(EventConstants.AJAX_COMMIT_APPLY_START);
            

            commitApply(payload.data).always(function () {

                ALikeStore.emit_event(EventConstants.AJAX_COMMIT_APPLY_COMPLETE);

                recode = ALikeStore.get_recordDetail(ALikeStore.get_currentRecord())

            }).done(function () {

                ALikeStore.emit_event(EventConstants.ACTION_SWITCH_QUOTE_RECORD_COMPLETE);

                if (ALikeStore.is_currentVersionValid()) {

                    recode = ALikeStore.get_recordDetail(ALikeStore.get_currentRecord())

                    fetchProductList(_currentVersionId,recode.inquiryType).done(function () {

                        ALikeStore.emit_event(EventConstants.AJAX_LOAD_PRODUCT_LIST_COMPLETE);
                    });
                }else{
                    ALikeStore.emit_event(EventConstants.PRODUCT_LIST_LOADING,[ true ]);
                }

            });

            break;

        case ActionConstants.INIT_TRIP_INFO:

            _tripId = payload.data.tripId;

            _tripInfo = payload.data;

            pollQuoteService.init( _tripId, _tripInfo.uid );

            var versionId = _tripInfo.versionId;
            var inquiryType = _tripInfo.inquiryType;

            _defaultVersionId = versionId;

            _leftQueryCnt = _tripInfo.userLeftQueryCnt;

            //列表请求两,上来就加载去掉,逻辑放到询价列表返回后请求
            /*fetchProductList(versionId,inquiryType).done(function () {

                console.log(111,ALikeStore.is_currentVersionValid())

                if (!ALikeStore.is_currentVersionValid()) {

                    ALikeStore.emit_event(EventConstants.AJAX_LOAD_PRODUCT_LIST_COMPLETE);
                }
            });*/

            break;
        case ActionConstants.FRESH_QUOTE_RESULT_LIST:

            var recode;

            ALikeStore.emit_event(EventConstants.AJAX_RETRIEVE_RECORD_LIST_START);

            fetchQuoteResults().done(function () {

                if (ALikeStore.is_currentVersionValid()) {

                    if (ALikeStore.is_productHasBeenLoaded(_currentVersionId)) {

                        ALikeStore.emit_event(EventConstants.AJAX_LOAD_PRODUCT_LIST_COMPLETE);

                    } else {

                        recode = ALikeStore.get_recordDetail(ALikeStore.get_currentRecord())

                        fetchProductList(_currentVersionId,recode.inquiryType).done(function () {

                            ALikeStore.emit_event(EventConstants.AJAX_LOAD_PRODUCT_LIST_COMPLETE);

                        });
                    }
                }else{

                    var versionId = _tripInfo.versionId;
                    var inquiryType = _tripInfo.inquiryType;

                    fetchProductList(versionId,inquiryType).done(function () {

                        if (!ALikeStore.is_currentVersionValid()) {

                            ALikeStore.emit_event(EventConstants.AJAX_LOAD_PRODUCT_LIST_COMPLETE);
                        }
                    });
                }
            }).always(function (res) {

                pollQuoteService.saveQuoteList(res || []);

                ALikeStore.emit_event(EventConstants.AJAX_RETRIEVE_RECORD_LIST_COMPLETE);

                ALikeStore.emit_event(EventConstants.START_DATE_CHANGE,[ALikeStore.get_currentStartDate()] );

                if (!ALikeStore.is_currentVersionValid() && res.length !== 0 ) {
                     ALikeStore.emit_event(EventConstants.PRODUCT_LIST_LOADING,[ true ]);
                }

            });

            recode = ALikeStore.get_recordDetail(ALikeStore.get_currentRecord())


            break;
        case ActionConstants.SWITCH_QUOTE_RECORD:

            var inquiryKey = payload.data.inquiryKey;

            if (!inquiryKey) {

                inquiryKey = _currentRecordKey;
            }

            var versionId = payload.data.versionId;

            if (!versionId) {

                versionId = ALikeStore.get_recordDefaultVersion(inquiryKey, false);
            }

            if (payload.data.buyDate !== ""){

                _.each(payload.data.priceCalenderDataList, function (dayInfo) {
                    if (dayInfo.startDate === payload.data.buyDate) {

                        //如果当前版本被预定, 那么锁死产品列表

                        versionId = dayInfo.versionId;
                    }

                });

            }

            _currentRecordKey = inquiryKey;

            _currentVersionId = versionId;


            if( ! ALikeStore.is_currentVersionValid()){

                ALikeStore.emit_event(EventConstants.PRODUCT_LIST_LOADING,[ true ]);
            }

            // 设置行程类型
            _gradeType = ALikeStore.get_recordDetail( _currentRecordKey ).grade;

            ALikeStore.emit_event(EventConstants.ACTION_SWITCH_QUOTE_RECORD_COMPLETE);

            var productInfo = ALikeStore.get_productList(versionId);

            if (productInfo) {

                ALikeStore.emit_event(EventConstants.AJAX_LOAD_PRODUCT_LIST_COMPLETE);

            } else {

                if (ALikeStore.is_versionValid(versionId)) {

                    fetchProductList(versionId,payload.data.inquiryType).done(function () {

                        ALikeStore.emit_event(EventConstants.AJAX_LOAD_PRODUCT_LIST_COMPLETE);

                    });
                }
            }

            ALikeStore.emit_event(EventConstants.START_DATE_CHANGE,[ALikeStore.get_currentStartDate()] );

            break;


        case ActionConstants.TWEAK_QUOTE:

            var inquiryKey = payload.data.inquiryKey;

            if (!inquiryKey) {

                inquiryKey = _currentRecordKey;
            }

            var versionId = payload.data.versionId;

            if (!versionId) {

                versionId = ALikeStore.get_recordDefaultVersion(inquiryKey, false);
            }

            _currentRecordKey = inquiryKey;

            _currentVersionId = versionId;

            //ALikeStore.emit_event(EventConstants.ACTION_SWITCH_QUOTE_RECORD_COMPLETE);
            ALikeStore.emit_event(EventConstants.ACTION_TWEAK_QUOTE_START);

            break;

        case ActionConstants.ALERT_QUOTE_BECOME_INVALID:
            
            var inquiryKey = payload.data.inquiryKey;
            var record = ALikeStore.get_recordDetail(inquiryKey);
            
            if( typeof recode !== 'undefined' ){
                recode.isExpired = true;
            }
            
            ALikeStore.emit_event(EventConstants.AJAX_LOAD_PRODUCT_LIST_COMPLETE);
            break;

        case ActionConstants.ORDER:
            commitOrder().always(function () {
                ALikeStore.emit_event(EventConstants.AJAX_ORDER_COMPLETE);
            });
            break;
        case ActionConstants.SEND_TRIP_USER:
            sendTripUser().always( function () {
                ALikeStore.emit_event(EventConstants.AJAX_SEND_TRIP_USER_COMPLETE);
            })
            break;
        case ActionConstants.SELECTED_CALEANDAR_STARTDATE:
                var startDate = payload.data;
                _selectedStartDate = startDate

                ALikeStore.emit_event(EventConstants.ACTION_SELECTED_CALEANDAR_STARTDATE);

            break;
        case ActionConstants.SELECTED_CALEANDAR_STARTDATE_CONFIRM:
            var startDate = payload.data;
            _selectedStartDate = startDate

            ALikeStore.emit_event(EventConstants.ACTION_SELECTED_CALEANDAR_STARTDATE_CONFIRM);

            break;
        case ActionConstants.SWITCH_GRADE_TYPE:

            var versionId = payload.data.versionId;

            _gradeType = payload.data.gradeType;
            
            _defaultVersionId = versionId;

            var productInfo = _productInfo[versionId];

            ALikeStore.emit_event(EventConstants.ACTION_SWITCH_GRADE_TYPE);

            if (productInfo) {

                ALikeStore.emit_event(EventConstants.AJAX_LOAD_PRODUCT_LIST_COMPLETE);

            } else {

                fetchProductList(versionId).done(function () {

                    ALikeStore.emit_event(EventConstants.AJAX_LOAD_PRODUCT_LIST_COMPLETE);
                });
            }
            
            break;

        case ActionConstants.SEARCH_PORT_INFO:
                searchPortInfo().done(function(){
                    ALikeStore.emit_event(EventConstants.AJAX_SEARCH_PORT_INFO_COMPLETE);
                });
            break;

        case ActionConstants.INIT_LOCATION_DATA:

            _locationData = payload.data;
            _locationData.sorts = [
                {sortId: 1,sortName: "综合排序"},
                {sortId: 4,sortName: "天数"}
            ];
            break;
        case ActionConstants.SEARCH_POWER_LIST:
            searchPowerList(payload.data).done(function(){
                ALikeStore.emit_event(EventConstants.AJAX_SEARCH_POWER_LIST_COMPLETE);
            });
            break;
        case ActionConstants.LOAD_POWER_LIST:
            loadPowerList(payload.data).done(function(){
                ALikeStore.emit_event(EventConstants.AJAX_LOAD_POWER_LIST_COMPLETE);
            });
            break;
        case ActionConstants.FIRST_POWER_LIST_DATA:
            var firstPage= payload.data;
            _powerList = [firstPage];
            break;
        case ActionConstants.WALLE_HAS_START_FLA:
            var walleHasStartFalg = payload.data;
            _walleHasStartFalg = walleHasStartFalg;
            ALikeStore.emit_event(EventConstants.ACTION_WALLE_HAS_START_FLAG);
            break;
    }
});

/**
 * 提交报价申请
 * @param params
 */
function commitApply(params) {

    _errors[ActionConstants.COMMIT_APPLY] = null;

    var keyParam = ALikeStore.has_uidKey() ? { key: _tripInfo.key } : {};

    var deferred = post("/a/power/submit-query-request/", _.extend({tripId: _tripId}, params, keyParam), {type: 'json'});

    deferred.done(function (record) {

        formatQuote(record);

        _quoteRecordList.splice(0, 0, record);

        _currentRecordKey = record.inquiryKey;

        _currentVersionId = ALikeStore.get_recordDefaultVersion(_currentRecordKey, false);

        processQuoteRecordList();

        _leftQueryCnt = record.userLeftQueryCnt;

    });

    deferred.fail(function (res) {

        _errors[ActionConstants.COMMIT_APPLY] = res.msg;
    });

    return deferred;
}

/**
 * 获取报价申请结果列表
 * @returns {*}
 */
function fetchQuoteResults() {
    var deferred;

    if(! _tripInfo.key){
        deferred = post("/a/power/quote-list/trip-" + _tripId + "/", null, {type: 'json'});
    }else{
        deferred = post("/a/power/quote-list/trip-" + _tripId + "/", {key: _tripInfo.key}, {type: 'json'});
    }

    deferred.done(function (res) {

        _quoteRecordList = res || [];
        window.quoteRecordList = res || [];

        formatQuoteRecordList();

        var version = ALikeStore.get_versionDetail(_currentVersionId);

        if (!version) {

            _currentRecordKey = null;

            _currentVersionId = null;
        }

        processQuoteRecordList();

    });

    return deferred;
}

/**
 * 格式化报价记录
 * @param record
 */
function formatQuote(record) {
    var trip = ALikeStore.get_tripBasicInfo();

    var city = _.findWhere(StartCityList, {id: +record.startCity});

    record.city = city || StartCityList.BEIJING;

    // 设置询价记录的唯一标识
    var inquiryKey = record.cacheKey;

    if( record.quoteId !== 0 ){
        inquiryKey = inquiryKey + '-' + record.quoteId
    }
    
    record.inquiryKey = inquiryKey;

    var isExpired = false;
    
    if( record.expireTime ){
        
       isExpired =  moment(record.expireTime) < moment().valueOf();
        
    }
    
    record.isExpired = isExpired;
    
    _.each(record.priceCalenderDataList, function (dayInfo) {

        var versionId = dayInfo.versionId;
        
        // 设置是否过期
        dayInfo.isExpired = isExpired;

        // 不存在 versionId 则生成
        if ( typeof versionId === 'undefined' ) {

            versionId = record.inquiryKey + "-" + dayInfo.startDate;

            dayInfo.versionId = versionId;
            dayInfo.tempVersionId = true;
            
        }
        // versionId 为 0 则取quoteId
        if(  versionId === '0' || versionId === 0 ){

            
            if( record.quoteId ){
                dayInfo.versionId = record.quoteId ;
                
            }else{

                versionId = record.inquiryKey + "-" + dayInfo.startDate;
                dayInfo.versionId = versionId;
                dayInfo.tempVersionId = true;
            }
            
        }

        if (dayInfo.price > 0) {

            dayInfo.perPrice = Math.ceil(dayInfo.price / (record.adtCnt + record.chdCnt));

            dayInfo.amount = dayInfo.price;
        }
        //规则:2016.7.14修改,准AA报价,没有服务包可显示,影响1)底价列表 2)产品列表
        var dayProductValid = record.inquiryType===1 ? (dayInfo.price > 0 && dayInfo.hasService > 0) : dayInfo.price>0;

        dayInfo.valid = dayProductValid;

        if (dayInfo.startDate === record.startDate) {

            record.status = dayInfo.status;

            record.valid = dayInfo.valid;

            record.price = dayInfo.price;

            record.amount = dayInfo.amount;

            //准AB用到的条件,日期临近失效,默认出发日期距离当前日期小于12自然日
            record.isDateNear = moment(dayInfo.startDate).diff(moment(), 'days')>=12 ? false : true;
        }
    });

    //5天全部为询价Fatal,如:缺货/库存紧张 注:命名容易混..
    record.isAllMistake = _.where(record.priceCalenderDataList,{status: 2}).length==5 ? true : false;
}

/**
 * 格式化报价记录列表
 */
function formatQuoteRecordList() {

    _.each(_quoteRecordList, function (record) {

        formatQuote(record);
    });
}

/**
 * 处理quote record list
 * 如果没有默认选中的current record
 * 则进行选中
 */
function processQuoteRecordList() {

    var selectedRecord = null;

    var selectedVersion = null;

    var firstRecord = null;

    var firstVersion = null;

    var tripRecord = null;

    var tripVersion = null;

    var trip = ALikeStore.get_tripBasicInfo();
    var tripStatus = trip.tripStatus;

    if (_quoteRecordList.length > 5) {
        //当报价列表超过5个时, 只取前5个

        _quoteRecordList.splice(5, _quoteRecordList.length - 5);
    }

    _.each(_quoteRecordList, function (record) {

        _.each(record.priceCalenderDataList, function (dayInfo) {

            var versionId = dayInfo.versionId;

            var dayProductValid = dayInfo.valid;

            if (!_hasBought && (dayInfo.startDate === record.buyDate)) {

                _hasBought = true;

                //如果当前版本被预定, 那么锁死产品列表
                _currentRecordKey = record.inquiryKey;

                _currentVersionId = dayInfo.versionId;
            }

            if (!firstVersion && (dayInfo.startDate === record.startDate)) {

                firstRecord = record.inquiryKey;

                firstVersion = versionId;
            }

            if (!selectedVersion && dayProductValid && (dayInfo.startDate === record.startDate)) {

                selectedRecord = record.inquiryKey;

                selectedVersion = versionId;
            }
            //如果是准AB达人修改中,或者审核未通过时,取报价的
            if(!tripRecord && (+tripStatus === TripStatus.Edit.code || +tripStatus === TripStatus.Fail.code)){

                //是计价,取出发日期对应那天
                if( record.inquiryType===1 && (dayInfo.startDate === record.startDate)){

                    tripRecord = record.inquiryKey;

                    tripVersion = versionId;
                }
            }

            //if (dayProductValid) {

                if (_validVersionList.indexOf(versionId) === -1) {

                    _validVersionList.push(versionId);
                }
           /* } else {

                if (_validVersionList.indexOf(versionId) > -1) {

                    _validVersionList.splice(_validVersionList.indexOf(versionId), 1);
                }
            }*/
        });
    });

    _currentRecordKey = _currentRecordKey || tripRecord || selectedRecord || firstRecord;

    _currentVersionId = _currentVersionId || tripVersion || selectedVersion || firstVersion;
}

var processServesForProductInfo = function (productInfo) {

    var version =  ALikeStore.get_versionDetail(ALikeStore.get_currentVersion());

    if(version && !version.hasService){
        if(_.isUndefined(productInfo.out)){
            productInfo.out = {};
        }
        productInfo.out.service = ["行程大师六大服务包"];
    }

    return productInfo
};

/**
 * 获取指定产品列表
 * @param versionId
 */
function fetchProductList(versionId, inquiryType) {

    if( typeof inquiryType  === "undefined"){
        inquiryType = 1;
    }

    var data = {
        versionId: versionId,
        inquiryType:inquiryType,
        tid: _tripId,
        key: _tripInfo.key || ""
    }
    if(!_tripInfo.key){
        delete data.key;
    }

    var deferred = post("/a/power/product-info/", data, {type: 'json'});

    deferred.done(function (res) {

        _productInfo[versionId] = processServesForProductInfo(res[versionId] || {});

        _planeInfo[versionId]  = res.planeInfo;

    });

    return deferred;
}

/**
 *  提交订单
 */
function commitOrder() {
    var versionDetail = ALikeStore.get_versionDetail(_currentVersionId);

    _errors[ActionConstants.ORDER] = null;

    _lastCommitVersionId = _currentVersionId;

    var currentRecord = ALikeStore.get_recordDetail(_currentRecordKey);

    var param = {
        tripId : _tripId,
        inquiryType: currentRecord.inquiryType,
        startDate: versionDetail.startDate,
        key: _tripInfo.key || ""
    };

    if(!_tripInfo.key){
        delete param.key;
    }
    
    // 设置报价和计价不同的参数:
    // 报价需要 quoteId
    // 计价需要 cacheKey
    if( ALikeStore.is_quote(_currentRecordKey) ){
        
        param.quoteId = currentRecord.quoteId;
        
    }else{
        
        param.cacheKey = currentRecord.cacheKey;
        
    }

    var deferred = post("/a/power/book/", param , {type: 'json'});

    deferred.done(function (data) {

        _confirmUrl = {web: data.web_url, mobile: data.h5_url};
    });

    deferred.fail(function (res) {

        _errors[ActionConstants.ORDER] = res.msg;
        _errorsCode[ActionConstants.ORDER] = res.code;

    });

    return deferred;
}
/**
 * 提交行程给用户
 * @param versionId
 */
function sendTripUser() {
    var deferred = post("/a/trip/walle/commit/", {

        tid: _tripId

    }, {type: 'json'});

    deferred.fail(function (res) {

        _errors[ActionConstants.SEND_TRIP_USER] = res.msg;
    });
    return deferred;
}

function searchPortInfo() {
    var params = {
        tid: _tripId
    }
    var deferred = query("/a/power/port-info/", params, {type: 'json'});

    deferred.done(function (res) {
        _portInfo = res;
    });

    return deferred;
}


/**
 * 获取产品列表
 * @param versionId
 */
function searchPowerList(params) {

    var deferred = query("/a/powers/", params, {type: 'json'});

    deferred.done(function (res) {
        _powerList = !res ? [] : [res];
        _isPowerListLast = false;
    });

    return deferred;
}
/**
 * 滚动加载列表
 * @param params
 * @returns {*}
 */
function loadPowerList(params) {

    var deferred = query("/a/powers/", params, {type: 'json'});

    deferred.done(function (res) {
        if(res){
            _powerList.push(res);
            _isPowerListLast = false;
        }else{
            _isPowerListLast = true;
        }
    });

    return deferred;
}


module.exports = ALikeStore;



/** WEBPACK FOOTER **
 ** ./script/store/ALikeStore.js
 **/